<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />

    <v-col lg="12" class="ml-auto"></v-col>

    <b-card
      v-if="
        $router.currentRoute.path ==
        '/' + role + '/ordersPerStatus/' + $route.params.id
      "
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <template v-slot:header>
        <h5>
          آرشیو استعلام‌های وضعیت «
          <strong
            v-html="allStatuses.filter((x) => x.id == $route.params.id)[0].name"
          ></strong
          >»
        </h5>
        <h6 v-if="!isBusy">تعداد کل: {{ orders.length }}</h6>
      </template>
      <loading v-if="vLoading" />
      <br />
      <b-card class="shadow p-3 mb-5 bg-white rounded">
        <v-row class="pb-0 mt-3">
          <v-col cols="8">
            <v-text-field
              clearable
              v-model="filter"
              placeholder="جستجو"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-btn
              class="darkGreen-mainBtn white--text float-end"
              @click="$refs.activeTable.$el.click()"
              depressed
              style="width: 135px; height: 35px"
              :disabled="!orders.length"
            >
              <v-icon class="me-1"> mdi-file-excel-outline </v-icon>
              خروجی اکسل
            </v-btn>
            <vue-excel-xlsx
              ref="activeTable"
              :data="orders"
              :columns="ExcelFields"
              :sheet-name="`آرشیو استعلام‌ها`"
              :file-name="`آرشیو استعلام‌ها`"
            ></vue-excel-xlsx>
          </v-col>
          <v-col cols="2">
            <v-btn
              :disabled="gettingReceipt || !orders.length"
              class="darkRed-mainBtn white--text float-end"
              style="width: 135px; height: 35px"
              @click="printReceipt()"
              depressed
              ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
            >
          </v-col>
        </v-row>
        <br />
        <b-table
          responsive
          show-empty
          id="allOrders-tabel"
          :items="orders"
          :fields="fields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد"
          striped
          :current-page="allCurrentPage"
          :per-page="perPage"
          :busy="isBusy"
          :filter="filter"
          @filtered="onFiltered"
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(code)="data">
            <div style="text-align: center; vertical-align: middle">
              <a
                :href="'/' + role + '/order/' + data.item.id"
                target="_blank"
                >{{ data.item.code }}</a
              >
              <span v-if="data.item.isUrgent" class="text-danger">
                <i class="mr-1 fa fa-exclamation-triangle"> </i>
                فوری
              </span>
            </div>
          </template>
          <template v-slot:cell(customerName)="data">
            <div style="text-align: center; vertical-align: middle">
              <a
                v-if="role != 'tradeIntern'"
                :href="'/' + role + '/customerProfile/' + data.item.customerId"
                >{{ data.item.customerName }}</a
              >
              <span v-else>{{ data.item.customerName }}</span>
            </div>
          </template>
          <template v-slot:cell(operation)="row">
            <b-button
              v-if="row.item._showDetails"
              variant="danger"
              @click="row.toggleDetails"
              >بستن
            </b-button>
            <b-button v-else variant="primary" @click="row.toggleDetails"
              >عملیات
            </b-button>
          </template>

          <template #row-details="row">
            <div
              class="animated fadeIn"
              style="text-align: center; vertical-align: middle"
            >
              <a
                class="btn btn-dark mr-1 mt-1"
                :href="'/' + role + '/printPreview/' + 'full/' + row.item.id"
                v-if="
                  row.item.status != 'ثبت استعلام' &&
                  row.item.status != 'اعلام تعیین قیمت به مشتری'
                "
                target="_blank"
                role="button"
                >نسخه چاپی</a
              >
              <b-btn
                variant="success"
                class="mr-1 mt-1"
                v-if="row.item.status == 'اعلام تعیین قیمت به مشتری'"
                @click="openModalCustomer(row.item)"
                >ارسال تعیین قیمت به مشتری</b-btn
              >&nbsp;
              <b-btn
                variant="danger"
                class="mr-1 mt-1"
                v-if="
                  (role == 'Manager' || role == 'salesManager') &&
                  row.item.status != 'عدم' &&
                  row.item.status != 'آرشیو'
                "
                @click="showRejectModal(row.item)"
                >عدم</b-btn
              >&nbsp;
              <b-btn
                variant="success"
                class="mr-1 mt-1"
                v-if="row.item.status == 'در انتظار نظر مشتری'"
                @click="openModalGet(row.item)"
                >دریافت پاسخ مشتری</b-btn
              >&nbsp;
              <b-btn
                variant="primary"
                class="mr-1 mt-1"
                @click="showModalFollow(row.item)"
                >ثبت پیگیری</b-btn
              >&nbsp;
              <b-btn
                class="mr-1 mt-1"
                variant="success"
                @click="assignToMe(row.item)"
                v-if="
                  row.item.assigneeName == '-' &&
                  role != 'secretary' &&
                  role != 'queryOrganizer' &&
                  row.item.status != 'عدم' &&
                  row.item.status != 'آرشیو'
                "
                >تخصیص به من</b-btn
              >&nbsp;
              <b-btn
                class="mr-1 mt-1"
                variant="danger"
                @click="openRemoveAssigneeDialog(row.item)"
                v-if="
                  row.item.assigneeName != '-' &&
                  role != 'secretary' &&
                  role != 'trade' &&
                  role != 'tradeIntern' &&
                  role != 'queryOrganizer' &&
                  row.item.status != 'عدم' &&
                  row.item.status != 'آرشیو'
                "
                >حذف مجری</b-btn
              >&nbsp;
              <b-btn
                class="mr-1 mt-1"
                variant="warning"
                @click="assignToEmployee(row.item)"
                v-if="row.item.assigneeName == '-' && role == 'Manager'"
                >تخصیص به همکاران</b-btn
              >&nbsp;
              <a
                class="btn btn-success mr-1 mt-1"
                :href="
                  '/' +
                  role +
                  '/query/' +
                  row.item.customerId +
                  '/' +
                  row.item.id
                "
                v-if="
                  (role == 'salesManager' || role == 'Manager') &&
                  row.item.status == 'بررسی تعیین قیمت توسط مدیر فروش'
                "
                target="_blank"
                role="button"
                >بررسی تعیین قیمت</a
              >&nbsp;
              <a
                class="btn btn-success mr-1 mt-1"
                :href="'/queryOrganizer/analyze/' + row.item.id"
                v-if="
                  (role == 'queryOrganizer' ||
                    role == 'Manager' ||
                    role == 'trade' ||
                    role == 'tradeHead' ||
                    role == 'salesManager') &&
                  row.item.status == 'تایید تعیین قیمت توسط مشتری'
                "
                target="_blank"
                role="button"
                >بررسی نهایی اقلام استعلام</a
              >&nbsp;
              <a
                class="btn btn-success mr-1 mt-1"
                :href="
                  '/' +
                  role +
                  '/query/' +
                  row.item.customerId +
                  '/' +
                  row.item.id
                "
                v-if="
                  (role == 'salesManager' ||
                    role == 'Manager' ||
                    role == 'ceo') &&
                  row.item.status == 'تعیین قیمت توسط مدیر عامل'
                "
                target="_blank"
                role="button"
                >تعیین قیمت</a
              >&nbsp;
              <a
                class="btn btn-success mr-1 mt-1"
                :href="
                  '/' +
                  role +
                  '/query/' +
                  row.item.customerId +
                  '/' +
                  row.item.id
                "
                v-if="
                  row.item.status == 'ثبت استعلام' &&
                  row.item.assigneeId == currentUserId
                "
                target="_blank"
                role="button"
                >ثبت استعلام</a
              >&nbsp;
              <a
                class="btn btn-success mr-1 mt-1"
                :href="
                  '/' +
                  role +
                  '/query/' +
                  row.item.customerId +
                  '/' +
                  row.item.id
                "
                v-if="
                  (role == 'salesManager' ||
                    role == 'Manager' ||
                    role == 'tradeHead') &&
                  row.item.status == 'در انتظار بررسی فنی'
                "
                target="_blank"
                role="button"
                >بررسی فنی</a
              >&nbsp;
              <a
                class="btn btn-success mr-1 mt-1"
                :href="
                  '/' +
                  role +
                  '/query/' +
                  row.item.customerId +
                  '/' +
                  row.item.id
                "
                v-if="
                  (role == 'ceo' || role == 'Manager') &&
                  row.item.status == 'آماده برای امضا'
                "
                target="_blank"
                role="button"
                >بررسی نهایی و امضا</a
              >&nbsp;
              <a
                class="btn btn-success mr-1 mt-1"
                :href="'/' + role + '/sendToFactory/' + row.item.id"
                v-if="
                  (role == 'Manager' ||
                    role == 'trade' ||
                    role == 'tradeHead' ||
                    role == 'salesManager') &&
                  row.item.status == 'آماده ارسال به کارخانه'
                "
                target="_blank"
                role="button"
                >ارسال به کارخانه</a
              >
            </div> </template
          >÷
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 + perPage * (allCurrentPage - 1) }}
            </div>
          </template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <strong>در حال بارگذاری...</strong>
            <br />
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </b-table>

        <b-pagination
          v-model="allCurrentPage"
          :total-rows="allTotalRows"
          :per-page="perPage"
          aria-controls="allOrders-tabel"
          align="center"
          size="md"
          class="my-0"
        ></b-pagination>
      </b-card>
    </b-card>

    <v-dialog v-model="followDialog" max-width="600px">
      <v-card>
        <v-card-title style="padding-top: 38px">
          <h4>توضیحات برای پرونده استعلام {{ currentOrder.code }}</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container>
            <p>
              همکار گرامی لطفا توضیحات پیگیری خود و همچنین فایل مربوطه را (در
              صورت وجود) وارد کنید
            </p>
            <div class="mb-2 item-ckeditor">
              <ckeditor
                v-model="content"
               :editor="editor"
                  :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
            <b-form-group label="بارگذاری فایل:">
              <b-form-file
                :state="Boolean(file)"
                @input="upload(file)"
                v-model="file"
                browse-text="آپلود"
                placeholder="فایل مربوطه را آپلود کنید"
                accept="*"
              ></b-form-file>
            </b-form-group>
            <br />
            <b-progress
              v-if="myFile.showProgress"
              :value="myFile.uploadPercentage"
              :max="max"
              show-progress
              :animated="myFile.striped"
              :variant="myFile.variant"
            ></b-progress>
            <v-row>
              <br />
              <div v-if="myFile.isUploaded" color="green" class="mt-3">
                فایل با موفقیت آپلود شد.
              </div>
              <br />
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="closeModalFollow()">
            لغو
          </v-btn>
          <v-btn color="primary" @click="submitFollowing()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="getCustomerDialog" max-width="700px">
      <v-card>
        <v-card-title style="padding-top: 38px">
          <h4>دریافت پاسخ مشتری {{ currentOrder.code }}</h4>
        </v-card-title>
        <v-card-text class="pb-0 pt-3 px-3">
          <v-container>
            <p>
              همکار گرامی لطفا توضیحات پاسخ مشتری و همچنین فایل مربوطه را (در
              صورت وجود) وارد کنید:
            </p>
            <div class="item-ckeditor">
              <ckeditor
                v-model="getContent"
              :editor="editor"
                  :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
            <hr />
            <b-form-group label="بارگذاری فایل:">
              <b-form-file
                :state="Boolean(file)"
                @input="upload(file)"
                v-model="file"
                browse-text="آپلود"
                placeholder="فایل مربوطه را آپلود کنید"
                accept="*"
              ></b-form-file>
            </b-form-group>
            <br />
            <b-progress
              v-if="myFile.showProgress"
              :value="myFile.uploadPercentage"
              :max="max"
              show-progress
              :animated="myFile.striped"
              :variant="myFile.variant"
            ></b-progress>
            <v-row>
              <br />
              <div v-if="myFile.isUploaded" color="green" class="mt-3">
                فایل با موفقیت آپلود شد.
              </div>
              <br />
            </v-row>
            <v-select
              v-model="response"
              :items="responses"
              label="پاسخ مشتری"
              outlined
              dense
              item-text="text"
              item-value="value"
            ></v-select>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="closeModalGet()">
            لغو
          </v-btn>
          <v-btn color="primary" @click="submitCustomerResponse()">
            دریافت پاسخ مشتری</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="followCustomerDialog" max-width="700px">
      <v-card>
        <v-card-title style="padding-top: 38px">
          <h4>ارسال تعیین قیمت {{ currentOrder.code }} به مشتری</h4>
        </v-card-title>
        <v-card-text class="pb-0 pt-3 px-3">
          <v-container>
            <b-card style="border: 0" class="mb-0">
              <b-card>
                <v-row class="mb-3">
                  <v-col cols="12">
                    <a
                      class="btn btn-dark mr-1 mt-1"
                      :href="
                        '/' +
                        role +
                        '/printPreview/' +
                        'full/' +
                        currentOrder.id
                      "
                      target="_blank"
                      role="button"
                      >نسخه چاپی استعلام</a
                    >
                  </v-col>
                </v-row>
                <p>
                  همکار گرامی لطفا توضیحات پاسخ مشتری و همچنین فایل مربوطه را
                  (در صورت وجود) وارد کنید:
                </p>
                <div class="item-ckeditor">
                  <ckeditor
                    v-model="followContent"
                    :editor="editor"
                  :config="editorConfig"
                    @blur="onBlur($event)"
                    @focus="onFocus($event)"
                    @contentDom="onContentDom($event)"
                    @dialogDefinition="onDialogDefinition($event)"
                    @fileUploadRequest="onFileUploadRequest($event)"
                    @fileUploadResponse="onFileUploadResponse($event)"
                  />
                </div>
                <hr />
                <b-form-group label="بارگذاری فایل:">
                  <b-form-file
                    :state="Boolean(file)"
                    @input="upload(file)"
                    v-model="file"
                    browse-text="آپلود"
                    placeholder="فایل مربوطه را آپلود کنید"
                    accept="*"
                  ></b-form-file>
                </b-form-group>
                <br />
                <b-progress
                  v-if="myFile.showProgress"
                  :value="myFile.uploadPercentage"
                  :max="max"
                  show-progress
                  :animated="myFile.striped"
                  :variant="myFile.variant"
                ></b-progress>
                <v-row>
                  <br />
                  <div v-if="myFile.isUploaded" color="green" class="mt-3">
                    فایل با موفقیت آپلود شد.
                  </div>
                  <br />
                </v-row>

                <v-select
                  :items="sendMethods"
                  v-model="sendMethod"
                  label="روش ارسال استعلام"
                  outlined
                  dense
                ></v-select>
              </b-card>
            </b-card>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="closeModalCustomer()">
            لغو
          </v-btn>
          <v-btn color="primary" @click="sendPrice()"> ارسال</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="rejectDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>دلیل رد استعلام {{ currentOrder.code }}</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container>
            <p>دلیل رد استعلام را وارد کنید.</p>
            <div class="mb-2 item-ckeditor">
              <ckeditor
                v-model="rejectReason"
               :editor="editor"
                  :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="rejectDialog = false">
            لغو
          </v-btn>
          <v-btn color="primary" @click="submitRejectReason()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="sendBackToCeoDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>برگشت {{ currentOrder.code }} به مدیریت جهت امضا</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container>
            <p>توضیحات</p>
            <div class="mb-2 item-ckeditor">
              <ckeditor
                v-model="rejectReason"
                :editor="editor"
                  :config="editorConfig"
                @blur="onBlur($event)"
                @focus="onFocus($event)"
                @contentDom="onContentDom($event)"
                @dialogDefinition="onDialogDefinition($event)"
                @fileUploadRequest="onFileUploadRequest($event)"
                @fileUploadResponse="onFileUploadResponse($event)"
              />
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="sendBackToCeoDialog = false"
          >
            لغو
          </v-btn>
          <v-btn color="primary" @click="sendBacktoCeo()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="removeAssigneeDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <h4>حذف مجری {{ currentOrder.code }}</h4>
        </v-card-title>
        <v-card-text class="py-2 text-center">
          <v-container>
            <h5>آیا از حذف مجری اطمینان دارید؟</h5>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-btn
            class="text-white mx-auto"
            color="red"
            @click="removeAssigneeDialog = false"
          >
            خیر
          </v-btn>
          <v-btn
            class="mx-auto"
            color="primary"
            @click="removeAssignee(selected)"
          >
            بله
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="assignToEmployeeDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <h4>تخصیص استعلام کد {{ currentOrder.code }}</h4>
        </v-card-title>
        <v-card-text class="py-2 text-center">
          <v-container>
            <h5>لطفا مجری مورد نظر را انتخاب کنید</h5>
            <v-select
              label="مجری انتخابی"
              :items="employees"
              v-model="selectedEmployee"
              outlined
              dense
            />
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-btn
            class="text-white mx-auto"
            color="red"
            @click="assignToEmployeeDialog = false"
          >
            لغو
          </v-btn>
          <v-btn
            class="mx-auto"
            color="primary"
            :disabled="!selectedEmployee"
            @click="doAssignToEmployee(selectedEmployee)"
          >
            تخصیص مجری
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <router-view></router-view>
    <div id="printTable" v-show="false">
      <h3 class="text-right" style="float: right">استعلام‌ها به تفکیک وضعیت</h3>
      <b-table :items="orders" :fields="printFields">
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import router from "../router";

import { CKEditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    CKEditor,
  },
  data: function () {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "subscript",
          "superscript",
          "fontColor",
        ],
        height: 200,
        language: 'fa',
        contentsLangDirection: 'rtl',
      },
      printInvoice: {},
      gettingReceipt: false,
      guide: false,
      removeAssigneeDialog: false,
      followContent: "",
      getContent: "",
      factory: new Object({
        code: "",
        dueDate: "",
      }),
      moment: moment,
      rejectReason: "",
      showProgress: false,
      uploadButDisable: false,
      variant: "info",
      striped: true,
      max: 100,
      uploadPercentage: 0,
      isUploaded: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      uploadedFiles: [],
      currentOrder: {},
      selectedOrder: {},
      items: [],
      filter: null,
      fields: [
        { key: "index", label: "ردیف" },
        { key: "code", label: "شماره پرونده" },
        { key: "requestId", label: "کد درخواست" },
        // { key: 'subject', label: 'عنوان استعلام' },
        { key: "customerName", label: "نام مشتری" },
        { key: "assigneeName", label: "کارشناس بازرگانی" },
        { key: "contactName", label: "نماینده مشتری" },
        { key: "registerDate", label: "تاریخ ثبت" },
        // { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      printFields: [
        { key: "index", label: "ردیف" },
        { key: "code", label: "شماره پرونده" },
        { key: "requestId", label: "کد درخواست" },
        { key: "customerName", label: "نام مشتری" },
        { key: "assigneeName", label: "کارشناس بازرگانی" },
        { key: "contactName", label: "نماینده مشتری" },
        { key: "registerDate", label: "تاریخ ثبت" },
      ],
      ExcelFields: [
        { field: "code", label: "شماره پرونده" },
        { field: "requestId", label: "کد درخواست" },
        { field: "customerName", label: "نام مشتری" },
        { field: "assigneeName", label: "کارشناس بازرگانی" },
        { key: "contactName", label: "نماینده مشتری" },
        { field: "registerDate", label: "تاریخ ثبت" },
      ],
      response: "none",
      responses: [
        {
          value: "none",
          text: "پاسخی دریافت نشده است",
          status: "در انتظار نظر مشتری",
        },
        {
          value: "yes",
          text: "با تعیین قیمت موافقم",
          status: "تایید تعیین قیمت توسط مشتری",
        },
        {
          value: "no",
          text: "با تعیین قیمت مخالفم",
          status: "رد تعیین قیمت توسط مشتری",
        },
        {
          value: "revision",
          text: "تعیین قیمت نیاز به بازبینی دارد",
          status: "بازبینی تعیین قیمت",
        },
      ],
      statusOptions: [
        { value: "ثبت استعلام", text: "ثبت استعلام" },
        { value: "در انتظار بررسی فنی", text: "در انتظار بررسی فنی" },
        {
          value: "تعیین قیمت توسط مدیر عامل",
          text: "تعیین قیمت توسط مدیر عامل",
        },
        {
          value: "بررسی تعیین قیمت توسط مدیر فروش",
          text: "بررسی تعیین قیمت توسط مدیر فروش",
        },
        { value: "آماده برای امضا", text: "آماده برای امضا توسط مدیر عامل" },
        {
          value: "اعلام تعیین قیمت به مشتری",
          text: "اعلام تعیین قیمت به مشتری",
        },
        // {
        //   value: "تایید تعیین قیمت توسط مشتری",
        //   text: "تایید تعیین قیمت توسط مشتری"
        // }
        // { value: "بازبینی تعیین قیمت", text: "بازبینی تعیین قیمت (آرشیو)" },
      ],
      currentPage: 1,
      perPage: 10,
      isBusy: false,
      TotalRows: 1,
      allTotalRows: 1,
      allCurrentPage: 1,
      striped: true,
      uniqueValues: [],
      content: "",
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },
      sendMethod: "",
      sendMethods: [
        { value: "packet", text: "پاکت دربسته" },
        { value: "email", text: "ایمیل" },
        { value: "fax", text: "فاکس" },
        { value: "whatsapp", text: "واتساپ" },
        { value: "other", text: "سایر روش‌ها (در توضیحات ذکر شود)" },
      ],
      role: "",
      currentUserId: "",
      followDialog: false,
      getCustomerDialog: false,
      followCustomerDialog: false,
      rejectDialog: false,
      sendBackToCeoDialog: false,
      selected: "",
      orders: [],
      statuses: [
        "ثبت استعلام",
        "در انتظار بررسی فنی",
        "تعیین قیمت توسط مدیر عامل",
        "بررسی تعیین قیمت توسط مدیر فروش",
        "آماده برای امضا",
        "اعلام تعیین قیمت به مشتری",
        "در انتظار نظر مشتری",
        "تایید تعیین قیمت توسط مشتری",
        "رد تعیین قیمت توسط مشتری",
        "عدم",
        "آرشیو",
        "بازبینی تعیین قیمت",
        "آماده ارسال به کارخانه",
        "ارسال به کارخانه",
      ],
      allStatuses: [
        {
          id: 1,
          name: '<i class="fa fa-gear" aria-hidden="true"></i> ثبت استعلام',
        },
        {
          id: 2,
          name: '<i class="fa fa-gears" aria-hidden="true"></i> در انتظار بررسی فنی',
        },
        {
          id: 3,
          name: '<i class="fa fa-dollar" aria-hidden="true"></i> تعیین قیمت توسط مدیر عامل',
        },
        {
          id: 4,
          name: '<i class="fa fa-money" aria-hidden="true"></i> بررسی تعیین قیمت توسط مدیر فروش',
        },
        {
          id: 5,
          name: '<i class="fa fa-pencil-square-o" aria-hidden="true"></i> آماده برای امضا',
        },
        {
          id: 6,
          name: '<i class="fa fa-bullhorn" aria-hidden="true"></i> اعلام تعیین قیمت به مشتری',
        },
        {
          id: 7,
          name: '<i class="fa fa-clock-o" aria-hidden="true"></i> در انتظار نظر مشتری',
        },
        {
          id: 8,
          name: '<i class="fa fa-check-square-o" aria-hidden="true"></i> تایید تعیین قیمت توسط مشتری',
        },
        {
          id: 9,
          name: '<i class="fa fa-times-rectangle-o" aria-hidden="true"></i> رد تعیین قیمت توسط مشتری',
        },
        { id: 10, name: '<i class="fa fa-deaf" aria-hidden="true"></i> عدم' },
        {
          id: 11,
          name: '<i class="fa fa-archive" aria-hidden="true"></i> آرشیو',
        },
        {
          id: 12,
          name: '<i class="fa fa-spinner" aria-hidden="true"></i> بازبینی تعیین قیمت',
        },
        {
          id: 13,
          name: '<i class="fa fa-thumbs-o-up" aria-hidden="true"></i> آماده ارسال به کارخانه',
        },
        {
          id: 14,
          name: '<i class="fa fa-send-o" aria-hidden="true"></i> ارسال به کارخانه',
        },
      ],
      allStatusesRequest: [
        { id: 1, name: "ثبت استعلام" },
        { id: 2, name: "در انتظار بررسی فنی" },
        { id: 3, name: "تعیین قیمت توسط مدیر عامل" },
        { id: 4, name: "بررسی تعیین قیمت توسط مدیر فروش" },
        { id: 5, name: "آماده برای امضا" },
        { id: 6, name: "اعلام تعیین قیمت به مشتری" },
        { id: 7, name: "در انتظار نظر مشتری" },
        { id: 8, name: "تایید تعیین قیمت توسط مشتری" },
        { id: 9, name: "رد تعیین قیمت توسط مشتری" },
        { id: 10, name: "عدم" },
        { id: 11, name: "آرشیو" },
        { id: 12, name: "بازبینی تعیین قیمت" },
        { id: 13, name: "آماده ارسال به کارخانه" },
        { id: 14, name: "ارسال به کارخانه" },
      ],
      currentId: null,
      assignToEmployeeDialog: false,
      selectedEmployee: {},
      employees: [],
      statuses: [
        { value: "active", text: "فعال" },
        { value: "deactive", text: "غیرفعال" },
      ],
      roles: [
        { value: "Manager", text: "مدیر" },
        { value: "ceo", text: "مدیرعامل" },
        { value: "secretary", text: "منشی" },
        { value: "trade", text: "کارشناس بازرگانی" },
        { value: "tradeIntern", text: "کارآموز بازرگانی" },
        { value: "tradeHead", text: "کارشناس فنی" },
        { value: "queryOrganizer", text: "بازرس سفارشات" },
        { value: "accountant", text: "حسابدار"},
        { value: "salesManager", text: "مدیر فروش" },
        { value: "factory", text: "مدیر کارخانه" },
        { value: "factoryTechnical", text: "مسئول فنی کارخانه" },
        { value: "qa", text: "QA & DCC" },
        { value: "qc", text: "مدیر کنترل کیفیت و آزمایشگاه" },
        { value: "qcAgent", text: "کنترل کیفی" },
        { value: "qcDocument", text: "سرتیفیکیت" },
        { value: "factoryPacking", text: "مسئول پکینگ" },
        { value: "production", text: "مدیر خط تولید" },
        { value: "delivery", text: "دلیوری" },
        { value: "coldForgingSupervisor", text: "سرپرست فورج سرد" },
        { value: "cuttingNutSupervisor", text: "مهره‌تراش" },
        { value: "coatingSupervisor", text: "داک و پوشش" },
        { value: "threadingSupervisor", text: "سرپرست رزوه زنی" },
        { value: "machiningSupervisor", text: "سرپرست ماشین کاری و فرزکاری" },
        { value: "cncSupervisor", text: "سرپرست CNC" },
        { value: "knittingSupervisor", text: "سرپرست قلاویز زنی و مهره تراشی" },
        { value: "weldingSupervisor", text: "سرپرست جوشکاری" },
        {
          value: "heatTreatmentSupervisor",
          text: "سرپرست عملیات حرارتی و سیاه کاری",
        },
        { value: "hotForgingSupervisor", text: "سرپرست فورج گرم" },
        { value: "dichromateSupervisor", text: "سرپرست داکرومات" },
        { value: "cuttingSupervisor", text: "سرپرست برشکاری" },
        { value: "factoryGeneral", text: "کارمند کارخانه" },
        { value: "warehouse", text: "مسئول کل انبار" },
        { value: "productsWarehouse", text: "مسئول انبار محصولات" },
        { value: "materialsWarehouse", text: "مسئول انبار مواد اولیه" },
        { value: "toolsWarehouse", text: "مسئول انبار ملزومات" },
        { value: "shop", text: "مسئول فروشگاه" },
      ],
    };
  },

  methods: {
    print(item) {
      this.gettingReceipt = true;
      Axios.post(
        this.baseUrl + "/ppkpms/orders/getInfo",
        {
          shopInvoiceId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printInvoice = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .then(() => {
          setTimeout(() => {
            this.printReceipt();
          }, 400);
        })
        .catch((err) => {
          console.log(err);
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "printTable", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title></title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("printTable").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },

    toggleHelp() {
      this.guide = !this.guide;
    },
    printPreview(order, type) {
      this.$router.push(
        "/" + this.role + "/" + "printPreview/" + type + "/" + order.id
      );
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.allTotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    assignToMe(order) {
      Axios.post(
        this.baseUrl + "/ppkpms/order/assignToMe",
        { orderId: order.id },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.showOrders();
            this.toast(res.data, "success");
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    customerResponse() {
      Axios.post(
        this.baseUrl + "/ppkpms/order/customerResponse",
        {
          orderId: this.$route.params.id,
          // targetFile:this.,
          sendMethod: this.response,
          note: this.getContent,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("عملیات موفق", "success");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    openRemoveAssigneeDialog(item) {
      this.selected = item.id;
      this.removeAssigneeDialog = true;
    },
    removeAssignee(order) {
      Axios.post(
        this.baseUrl + "/ppkpms/order/removeAssignee",
        { orderId: order },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.showOrders();
            this.removeAssigneeDialog = false;
            this.toast(res.data, "success");
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    sendBacktoCeo() {
      Axios.post(
        this.baseUrl + "/ppkpms/order/sendBacktoCeo",
        { orderId: this.selectedOrder.id },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.toast(res.data, "success");
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    showOrders() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/orders/getByStatus",
        {
          status: this.allStatusesRequest.filter(
            (x) => x.id == this.$route.params.id
          )[0].name,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.orders = res.data;
            this.TotalRows = this.orders.length;
            this.allTotalRows = this.orders.length;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    updateOrders() {
      Axios.post(
        this.baseUrl + "/ppkpms/orders/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.orders = res.data;
            this.TotalRows = this.orders.length;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    showRejectModal(order) {
      this.rejectDialog = true;
      this.currentOrder = order;
      this.rejectReason = "";
    },
    showSendBacktoCeo(order) {
      this.sendBackToCeoDialog = true;
      this.selectedOrder = order;
    },
    submitRejectReason() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/rejectOrder",
        {
          orderId: this.currentOrder.id,
          note: this.rejectReason,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.vLoading = false;
          if (res.status == 200) {
            this.rejectDialog = false;
            this.rejectReason = "";
            this.updateOrders();
            this.toast(res.data, "success");
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
        });
    },
    showModalFollow(order) {
      this.currentOrder = order;
      this.followDialog = true;
      this.content = "";
      this.file = [];
      this.uploadedFiles = [];
      this.myFile = new Object({
        uploadPercentage: 0,
      });
    },
    closeModalFollow() {
      this.currentOrder = {};
      this.followDialog = false;
    },
    submitFollowing() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/attachFile",
        {
          orderId: this.currentOrder.id,
          file: JSON.stringify(this.uploadedFiles),
          note: this.content,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.vLoading = false;
          if (res.status == 200) {
            this.followDialog = false;
            this.uploadedFiles = [];
            this.file = [];
            this.myFile = new Object({
              uploadPercentage: 0,
            });
            this.content = "";
            this.updateOrders();
            this.toast("پیگیری با موفقیت به استعلام اضافه گردید", "success");
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
        });
    },
    openModalGet(order) {
      this.currentOrder = order;
      this.getCustomerDialog = true;
      this.getContent = "";
      this.file = [];
      this.uploadedFiles = [];
      this.myFile = new Object({
        uploadPercentage: 0,
      });
    },
    closeModalGet() {
      this.currentOrder = {};
      this.getCustomerDialog = false;
    },
    submitCustomerResponse() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/customerResponse",
        {
          orderId: this.currentOrder.id,
          targetFile: JSON.stringify(this.uploadedFiles),
          customerResponse: this.response,
          note: this.getContent,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.vLoading = false;
          if (res.status == 200) {
            this.toast("نظر مشتری به ثبت رسید", "success");
            this.getCustomerDialog = false;
            this.getContent = "";
            this.file = [];
            this.uploadedFiles = [];
            this.myFile = new Object({
              uploadPercentage: 0,
            });
            this.updateOrders();
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
        });
    },
    openModalCustomer(order) {
      this.currentOrder = order;
      this.followCustomerDialog = true;
      this.followContent = "";
      this.sendMethod = "";
      this.file = [];
      this.uploadedFiles = [];
      this.myFile = new Object({
        uploadPercentage: 0,
      });
    },
    closeModalCustomer() {
      this.currentOrder = {};
      this.followCustomerDialog = false;
    },
    sendPrice() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/sendPrice",
        {
          orderId: this.currentOrder.id,
          targetFile: JSON.stringify(this.uploadedFiles),
          sendMethod: this.sendMethod,
          note: this.followContent,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.vLoading = false;
          if (res.status == 200) {
            this.followCustomerDialog = false;
            this.followContent = "";
            this.sendMethod = "";
            this.file = [];
            this.uploadedFiles = [];
            this.myFile = new Object({
              uploadPercentage: 0,
            });
            this.toast("استعلام برای مشتری ارسال شد", "success");
            this.updateOrders();
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
        });
    },
    showModalFollowPrice(order) {
      this.currentOrder = order;
      this.$refs["modalFollowPrice"].show();
    },
    closeModalFollowPrice() {
      this.currentOrder = {};
      this.$refs["modalFollowPrice"].hide();
    },
    showModalFollowCustomer(order) {
      this.currentOrder = order;
      this.$refs["modalFollowCustomer"].show();
    },
    closeModalFollowCustomer() {
      this.currentOrder = {};
      this.$refs["modalFollowCustomer"].hide();
    },
    showRejectReason(item) {
      this.selectedRequest = item;
      this.$refs["rejectReason"].show();
    },
    closeRejectReason() {
      this.rejectReason = "";
      this.selectedRequest = "";
      this.$refs["rejectReason"].hide();
    },
    upload(file) {
      // NOTE (m-myUpload) to upload files
      this.myFile.showProgress = true;
      this.myFile.variant = "info";
      this.myFile.uploadPercentage = 0;
      this.myFile.isUploaded = false;
      this.myFile.uploadButDisable = true;
      var formData = new FormData();
      formData.append(file.name, file);

      Axios.post(this.baseUrl + "/ppkpms/uploads/private", formData, {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
        onUploadProgress: ((progressEvent) => {
          this.myFile.uploadPercentage =
            Math.round((progressEvent.loaded * 100) / progressEvent.total) - 1;
        }).bind(this),
      })
        .then((d) => {
          if (d.status == 200) {
            this.myFile.isUploaded = true;
            this.myFile.uploadPercentage = 100;
            this.myFile.striped = false;
            this.myFile.variant = "success";
            this.myFile.uploadButDisable = false;
            this.uploadedFiles = d.data[0];
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    onBlur(evt) {},
    onFocus(evt) {},
    onContentDom(evt) {},
    onDialogDefinition(evt) {},
    onFileUploadRequest(evt) {},
    onFileUploadResponse(evt) {},
    assignToEmployee(order) {
      this.vLoading = true;
      this.currentOrder = order;
      this.selectedEmployee = {};
      Axios.post(
        this.baseUrl + "/ppkpms/users/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.employees = res.data;
          this.employees.forEach((person) => {
            try {
              person.roleName = this.roles.filter(
                (x) => x.value == person.role
              )[0].text;
            } catch (error) {
              person.roleName = "-";
            }

            try {
              person.statusName = this.statuses.filter(
                (x) => x.value == person.status
              )[0].text;
            } catch (error) {
              person.statusName = "-";
            }
          });

          this.employees = this.employees.filter(
            (employee) => employee.status == "active"
          );

          this.employees = this.employees.filter(
            (employee) =>
              employee.role == "trade" ||
              employee.role == "tradeIntern" ||
              employee.role == "tradeHead"
          );

          this.employees = this.employees.map((employee) => {
            return {
              value: employee.id,
              text:
                employee.name +
                " " +
                employee.lastName +
                " (نقش: " +
                employee.roleName +
                ")",
            };
          });

          this.vLoading = false;
          this.assignToEmployeeDialog = true;
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.vLoading = false;
        });
    },
    doAssignToEmployee(userId) {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/assignToUser",
        {
          orderId: this.currentOrder.id,
          userId: userId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.toast(res.data, "success");
          this.vLoading = false;
          this.assignToEmployeeDialog = false;
          this.showOrders();
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.vLoading = false;
        });
    },
  },

  mounted() {
    // this.getTableInfo()
    this.currentId = this.$route.params.id;
    this.showOrders();
    this.role = window.localStorage.getItem("role");
    this.currentUserId = window.localStorage.getItem("userId");
  },
  updated() {
    if (this.currentId != this.$route.params.id) {
      this.currentId = this.$route.params.id;
      this.showOrders();
    }
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
.nav-pills {
  padding: 10px !important;
}
</style>
